export default {"src":"/_next/static/media/2-nyt-logo.4fe1b5fb.svg","height":30,"width":182};